import { i18nService } from "services";

class FaqItem {
  faq: HTMLElement;
  question: HTMLElement | null;
  answer: HTMLElement | null;
  activeClass: string;
  inactiveClass: string;
  hiddenText: HTMLElement | null;

  constructor(
    faqItem: HTMLElement,
    headerClass: string,
    contentClass: string,
    activeClass: string,
    inactiveClass: string
  ) {
    this.faq = faqItem;
    this.question = faqItem.querySelector(headerClass);
    this.answer = faqItem.querySelector(contentClass);
    this.hiddenText = this.question
      ? this.question.querySelector(".visually-hidden")
      : null;
    this.activeClass = activeClass;
    this.inactiveClass = inactiveClass;
  }

  init() {
    if (this.faq && this.answer && this.question) {
      this.faq.classList.remove(this.activeClass);

      this.question.addEventListener("click", () => {
        this.toggleCollapse();
      });
    }
  }

  public toggleCollapse(): void {
    const isExpanded = this.faq.classList.toggle(this.activeClass);
    this.question?.setAttribute("aria-expanded", isExpanded.toString());

    if (this.hiddenText) {
      this.hiddenText.textContent = isExpanded
        ? i18nService.copy["a11y.collapse"]
        : i18nService.copy["a11y.expand"];
    }
  }
}

export default FaqItem;
